import { render } from "./SetPasswordComponent.vue?vue&type=template&id=d4f41a56"
import script from "./SetPasswordComponent.vue?vue&type=script&lang=js"
export * from "./SetPasswordComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__